<!-- eslint-disable @angular-eslint/template/no-inline-styles -->
<kendo-grid class="nova-grid"
            [scrollable]="scrollable"
            [loading]="isLoading"
            [skip]="args.skip"
            [pageSize]="args.pageSize"
            [pageable]="pageable"
            [filterable]="filterable"
            [filter]="filter"
            [sortable]="{allowUnsort: false, mode: 'single'}"
            [sort]="sort"
            [groupable]="groupable"
            [group]="group"
            [resizable]="resizable"
            [reorderable]="reorderable"
            [selectable]="selectable"
            [rowSelected]="isRowSelected"
            (selectionChange)="emitSelection($event)"
            [kendoGridSelectBy]="selectionKey"
            [(selectedKeys)]="selectedKeys"
            [rowClass]="rowClassCallback"
            (dataStateChange)="load($event)"
            (columnResize)="onColumnResize()"
            (columnReorder)="onColumnReordered($event)"
            (excelExport)="formatExcelData($event)"
            (cellClick)="onCellClicked($event)"
            [ngStyle]="style"
            [kendoGridExpandDetailsBy]="(useNewExpandCollapse) ? expandDetailsBy : null"
            [(expandedDetailKeys)]="expandedDetailKeys"
            (detailExpand)="detailExpand($event)"
            (detailCollapse)="detailCollapse($event)"
            (pageChange)="onPageChanged()"
>
    @if(needToolbar) {
    <ng-template kendoGridToolbarTemplate>
        <div class="nova-grid__column-menu">
            @if(needRefresh) {
                <button type="button" mat-icon-button data-qa-id="gridRefreshButton" (click)="reload()" title="Reload">
                    <mat-icon>cached</mat-icon>
                </button>
            }

            @if(needToolbarColumnShowHideMenu) {
                <button type="button" mat-icon-button [matMenuTriggerFor]="toolbarColumnMenu" title="Columns"
                    data-qa-id="gridColumnsButton" data-cy="sharedGridShowHideColumnMenuButton"
                    #toolbarColumnMenuTrigger="matMenuTrigger">
                    <mat-icon>view_week</mat-icon>
                </button>
            }

            @if(showClearFilterButton) {
                <button type="button" mat-icon-button color="filter-icon" class="app-grid-header-left-button" title="Clear Filters"
                    data-qa-id="gridClearFiltersButton" (click)="clearGridState()">
                    <mat-icon>filter_alt_off</mat-icon>
                </button>
            }

            @if(needExpandCollapseButtons) {
                @if(showExpandButton) {
                    <button type="button" [class.disabled]="enableDisableCollapseButtons && isAllExpanded"
                        [disabled]="enableDisableCollapseButtons && isAllExpanded" mat-icon-button class="expand-all-button"
                        (click)="expandAll()" title="Expand All"><i aria-hidden="true" class="material-icons"></i></button>
                }

                @if(showCollapseButton) {
                    <button type="button" [class.disabled]="enableDisableCollapseButtons && !isAllExpanded"
                        [disabled]="enableDisableCollapseButtons && !isAllExpanded" mat-icon-button class="collapse-all-button"
                        (click)="collapseAll()" title="Collapse All"><i aria-hidden="true" class="material-icons"></i></button>
                }
            }

            @for(toggle of toggles; track toggle.field) {
                <mat-slide-toggle #toggleElement [(ngModel)]="toggle.checked"
                    labelPosition="after" [disabled]="toggle.disabled" [matTooltip]="toggle.matTooltip"
                    (change)="toggleChange(toggle.field, $event.checked ? toggle.value : undefined)">
                    {{toggle.label}}
                </mat-slide-toggle>
            }

            @if(toolbarTemplate) {
                <ng-container [ngTemplateOutlet]="toolbarTemplate"></ng-container>
            }
        </div>

        @if(canExportToPdf || canExportToExcel || canExportToCSV) {
            <div class="nova-grid__export-menu">
                <button type="button" mat-stroked-button [matMenuTriggerFor]="exportMenu" color="secondary">Export</button>
            </div>
        }

        @if(directExportToExcel) {
            <div class="nova-grid__export-menu">
                <div kendoTooltip filter=".visible" position="bottom">
                    @if(!showExportToolTip) {
                        <button type="button" mat-stroked-button color="secondary" (click)="exportAllData('exportToExcel')">
                            EXPORT
                        </button>
                    } @else {
                        <button type="button" color="secondary" [title]="'Export is limited to ' + maxRecords + ' records'"
                            [class.visible]="maxPageSize === maxRecords" mat-stroked-button
                            (click)="exportAllData('exportToExcel')">EXPORT
                        </button>
                    }
                </div>
            </div>
        }

        @if(directExportSelectedRowsToExcel) {
            <div class="nova-grid__export-menu">
                <div kendoTooltip filter=".visible" position="bottom">
                    @if(!showExportToolTip) {
                        <button type="button" mat-stroked-button color="secondary" (click)="exportSelectedData('exportToExcel')"
                            [disabled]="selectedRows?.length === 0">
                            EXPORT SELECTED (
                            <span>{{selectedRows !== null && selectedRows !== undefined ? selectedRows.length : 0}}</span>)
                        </button>
                    } @else {
                        <button type="button" [title]="'Export is limited to ' + maxRecords + ' records'"
                            [disabled]="selectedRows?.length === 0 " [class.visible]="maxPageSize === maxRecords"
                            mat-stroked-button color="secondary" (click)="exportSelectedData('exportToExcel')">EXPORT
                            SELECTED(
                            <span>{{selectedRows !== null && selectedRows !== undefined ? selectedRows.length : 0}} </span>)
                        </button>
                    }
                </div>
            </div>
        }

        @if(specialPermissions()?.canBulkSetAutMatchSettings && !useBulkActionMenu) {
            <div class="nova-grid__assign-qm-menu">
                <button type="button" mat-flat-button color="primary" [class.disabled]="selectedRows.length === 0 || isLoading"
                    [disabled]="selectedRows.length === 0 || isLoading" (click)="onEditAutomatchSettingsClicked()"
                    data-qa-id="AssignQmButton">
                    Edit Automatch Settings&nbsp;
                </button>
            </div>
        }

        @if(specialPermissions()?.canBulkSetQmAutMatchSettings && !useBulkActionMenu) {
            <div class="nova-grid__assign-qm-menu">
                <button type="button" mat-flat-button color="primary" [class.disabled]="selectedRows.length === 0 || isLoading"
                    [disabled]="selectedRows.length === 0 || isLoading" (click)="onEditQmAutomatchSettingsClicked()"
                    data-qa-id="AssignQmButton">
                    Edit Automatch Settings&nbsp;
                </button>
            </div>
        }

        @if(specialPermissions()?.canAssignQm && !useBulkActionMenu) {
            <div class="nova-grid__assign-qm-menu">
                <button type="button" mat-flat-button color="primary" [class.disabled]="selectedRows.length === 0 || isLoading"
                    [disabled]="selectedRows.length === 0 || isLoading" (click)="onAssignQmClicked()"
                    data-qa-id="AssignQmButton">
                    Assign QM Association&nbsp;
                </button>
            </div>
        }

        @if(showBulkEditStatusButton && !useBulkActionMenu) {
            @if(specialPermissions()?.canEditQualificationMapping) {
                <div class="nova-grid__assign-qm-menu">
                    <button type="button" mat-stroked-button color="secondary" [class.disabled]="selectedRows.length === 0 || isLoading"
                        [disabled]="selectedRows.length === 0 || isLoading" (click)="onBulkEditQualificationMapping()"
                        data-qa-id="EditStatusButton">
                        Edit Status&nbsp;
                    </button>
                </div>
            }
        }

        @if(specialPermissions()?.canAddQm) {
            <div class="nova-grid__add-qm-menu">
                <button type="button" mat-flat-button color="primary" (click)="onAddQmClicked()" data-qa-id="AddQmButton">
                    Add QM Association&nbsp;
                </button>
            </div>
        }

        @if((specialPermissions()?.canReassignCS || specialPermissions()?.canUnassignCS) && !useBulkActionMenu) {
            <div
                class="nova-grid__reassign-cs-menu">
                <button type="button" mat-stroked-button color="secondary" [class.disabled]="selectedRows.length === 0 || isLoading"
                    data-qa-id="EditCsButton" [disabled]="selectedRows.length === 0 || isLoading"
                    [matMenuTriggerFor]="csMenu">
                    Edit CS&nbsp;<mat-icon [inline]="true" iconPositionEnd>arrow_drop_down</mat-icon>
                </button>
                <mat-menu #csMenu="matMenu">
                    @if(specialPermissions()?.canReassignCS) {
                        <button type="button" mat-menu-item (click)="onCSReassignClicked()">Reassign
                            CS
                        </button>
                    }

                    @if(specialPermissions()?.canUnassignCS) {
                        <button type="button" mat-menu-item (click)="onCSUnassignClicked()">Unassign
                            CS
                        </button>
                    }
                </mat-menu>
            </div>
        }

        @if((specialPermissions()?.canReassignCL || specialPermissions()?.canUnassignCL) && !useBulkActionMenu) {
            <div
                class="nova-grid__reassign-cs-menu">
                <button type="button" mat-stroked-button color="secondary" data-cy="EditClBtn" data-qa-id="EditClButton"
                    [class.disabled]="selectedRows.length === 0 || isLoading"
                    [disabled]="selectedRows.length === 0 || isLoading" [matMenuTriggerFor]="clMenu">
                    Edit CL&nbsp;<mat-icon [inline]="true" iconPositionEnd>arrow_drop_down</mat-icon>
                </button>
                <mat-menu #clMenu="matMenu">
                    @if(specialPermissions()?.canReassignCL) {
                        <button type="button" mat-menu-item (click)="onCLReassignClicked()"
                            data-cy="ReassignClBtn">Reassign CL</button>
                    }

                    @if(specialPermissions()?.canUnassignCL) {
                        <button type="button" mat-menu-item (click)="onCLUnassignClicked()"
                            data-cy="UnassignClBtn">Unassign CL</button>
                    }
                </mat-menu>
            </div>
        }

        @if(hasGridMenu) {
            <div class="">
                <button type="button" mat-icon-button [matMenuTriggerFor]="gridMenu">
                    <em class="material-icons">more_vert</em>
                </button>
            </div>
        }

        @if(useBulkActionMenu && selectable.enabled) {
            <div class="">
                <button type="button" mat-icon-button [matMenuTriggerFor]="bulkActionMenu" data-qa-id="BulkActionMenuButton">
                    <em class="material-icons">more_vert</em>
                </button>
            </div>
        }

        <ng-container [ngTemplateOutlet]="sendJobsTemplate"></ng-container>
    </ng-template>
    }

    @if(singleSelection && selectable?.mode === 'single') {
        <kendo-grid-checkbox-column [width]="35">
            <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem="dataItem">
                @if(!selectableResolver || selectableResolver(dataItem)) {
                    <input type="radio" [kendoGridSelectionCheckbox]="rowIndex" class="k-radio"
                        [id]="'radio-' + rowIndex" />
                    <label class="k-radio-label" [for]="'radio-' + rowIndex"></label>
                }
            </ng-template>
        </kendo-grid-checkbox-column>
    }

    @if(!persistSelection && selectable?.mode === 'multiple') {
        <kendo-grid-checkbox-column [showSelectAll]="true" [width]="35">
            <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem="dataItem">
                @if(!selectableResolver || selectableResolver(dataItem)) {
                    <div [title]="selectHintResolver ? selectHintResolver(dataItem) : ''">
                        <input type="checkbox"
                            [disabled]="!(!selectableDisabledResolver || !selectableDisabledResolver(dataItem))"
                            [kendoGridSelectionCheckbox]="rowIndex"
                            [title]="selectHintResolver ? selectHintResolver(dataItem) : ''" class="k-checkbox"
                            [id]="'checkbox-' + rowIndex" (change)="individualItemChange()" />
                        <label class="k-checkbox-label" [for]="'checkbox-' + rowIndex"></label>
                    </div>
                }
            </ng-template>
             <ng-template kendoGridHeaderTemplate>
               <input class="k-checkbox" [id]="headerCheckboxSelector()" type="checkbox" (change)="onSelectAll($event)" />
               <label class="k-checkbox-label" [for]="headerCheckboxSelector()"></label>
            </ng-template>
        </kendo-grid-checkbox-column>
    }

    @if(persistSelection && selectable?.mode === 'multiple') {
        <kendo-grid-checkbox-column [showSelectAll]="true" [width]="35" />
    }

    @for(column of columns; track column.field) {
        <kendo-grid-column [field]="column.sortField ? column.sortField : column.field"
            [title]="column.title" [filterable]="isGridFilterable(column)" [minResizableWidth]="column.minResizableWidth"
            [sortable]="column.sortable" [hidden]="column.hiddenSig()" [width]="column.width" [class]="column.class"
            [headerStyle]="column.headerStyle" [style]="column.style">
            @if(!column.template) {
                <!-- built-in cell templates -->
                    @if(column.format === 'date') {
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem[column.field] | date:'shortDate' }}
                        </ng-template>
                    }

                    @if(column.format === 'currency') {
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem[column.field] | currency }}
                        </ng-template>
                    }

                    @if(column.format === 'boolean') {
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem[column.field] | boolean }}
                        </ng-template>
                    }
            }

            @if(column.headerTemplate) {
                <!-- custom header template -->
                <ng-template kendoGridHeaderTemplate let-value="value">
                    <ng-container [ngTemplateOutlet]="column.headerTemplate" [ngTemplateOutletContext]="{ column: column }">
                    </ng-container>
                </ng-template>
            }

            @if(column.template) {
                <!-- custom cell template -->
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <ng-container [ngTemplateOutlet]="column.template"
                        [ngTemplateOutletContext]="{ dataItem: dataItem, rowIndex: rowIndex, column: column }"></ng-container>
                </ng-template>
            }

            @if(column.groupTemplate) {
                <ng-template kendoGridGroupHeaderTemplate let-value="value">
                    <ng-container [ngTemplateOutlet]="column.groupTemplate" [ngTemplateOutletContext]="{ value: value }">
                    </ng-container>
                </ng-template>
            }

            @if(!column.filterTemplate) {
                <!-- built-in filter templates -->
                    @if(column.filterType === 'text') {
                        <ng-template kendoGridFilterMenuTemplate let-column="column"
                            let-filter="filter" let-filterService="filterService">
                            <nova-text-filter [field]="column.field" [title]="column.title" [filter]="filter"
                                [filterService]="filterService">
                            </nova-text-filter>
                        </ng-template>
                    }

                    @if(column.filterType === 'checkbox') {
                        <ng-template kendoGridFilterMenuTemplate let-filter="filter"
                            let-filterService="filterService">
                            <nova-checkbox-filter [field]="column.field" [options]="column.filterOptions" [filter]="filter"
                                [uniqueFilterClass]="column.field + '-' + column.filterType + '-filter'"
                                [filterService]="filterService" [filterStyle]="column.filterStyle">
                            </nova-checkbox-filter>
                        </ng-template>
                    }

                    @if(column.filterType === 'multiselect') {
                        <ng-template kendoGridFilterMenuTemplate let-filter>
                            <nova-multiselect-filter-row [field]="column.field" [title]="column.title" [data]="column.filterOptions"
                                [valueField]="column.valueField" [textField]="column.textField" [showIcon]="column.showIcon"
                                [allowCustom]="column.filterByCustomValue" [applyFilterOnChange]="column.applyFilterOnChange"
                                [filter]="filter" hideAutocomplete>
                            </nova-multiselect-filter-row>
                        </ng-template>
                    }

                    @if(column.filterType === 'multiselect') {
                        <ng-template kendoGridFilterCellTemplate let-filter>
                            <nova-multiselect-filter-row [field]="column.field" [data]="column.filterOptions"
                                [valueField]="column.valueField" [textField]="column.textField" [showIcon]="column.showIcon"
                                [allowCustom]="column.filterByCustomValue" [applyFilterOnChange]="column.applyFilterOnChange"
                                [filter]="filter" [uniqueFilterClass]="column.field + '-' + column.filterType + '-filter'"
                                hideAutocomplete>
                            </nova-multiselect-filter-row>
                        </ng-template>
                    }

                    @if(column.filterType === 'autocomplete-multiselect') {
                        <ng-template kendoGridFilterCellTemplate
                            kendoGridFilterMenuTemplate let-filter>
                            <grid-option-autocomplete-multiselect-filter [field]="column.field" [data]="column.filterOptions"
                                [persistLookup]="column.persistLookup" [maxDataRows]="column.maxFilterOptionRows"
                                [searchText]="column.searchText" [minInputLength]="column.minFilterInputLength" [isCheckbox]="false"
                                [filterService]="filterService" [filter]="filter"
                                [uniqueFilterClass]="column.field + '-' + column.filterType + '-filter'">
                            </grid-option-autocomplete-multiselect-filter>
                        </ng-template>
                    }

                    @if(column.filterType === 'autocomplete-multiselect-checkbox') {
                        <ng-template kendoGridFilterCellTemplate
                            kendoGridFilterMenuTemplate let-filter>
                            <grid-option-autocomplete-multiselect-filter [field]="column.field" [data]="column.filterOptions"
                                [maxDataRows]="column.maxFilterOptionRows" [searchText]="column.searchText"
                                [valueField]="column.valueField || 'id'" [persistLookup]="column.persistLookup"
                                [selectAll]="column.selectAllFilterOptions" [minInputLength]="column.minFilterInputLength"
                                [isCheckbox]="true" [filterService]="filterService" [filter]="filter" [gridService]="gridService"
                                [gridName]="getName()" [onSaveColumns]="onSaveColumns.asObservable()"
                                [onResetColumns]="onResetColumns.asObservable()"
                                [uniqueFilterClass]="column.field + '-' + column.filterType + '-filter'">
                            </grid-option-autocomplete-multiselect-filter>
                        </ng-template>
                    }

                    @if(column.filterType === 'dropdown') {
                        <ng-template kendoGridFilterCellTemplate let-filter>
                            <nova-dropdown-filter-row [field]="column.field" [data]="column.filterOptions"
                                [valueField]="column.valueField" [textField]="column.textField" [filter]="filter"
                                [defaultItemText]="column.defaultItemText" [popupWidth]="column.popupWidth"
                                [uniqueFilterClass]="column.field + '-' + column.filterType + '-filter'">
                            </nova-dropdown-filter-row>
                        </ng-template>
                    }

                    @if(column.filterType === 'daterange') {
                        <ng-template kendoGridFilterMenuTemplate let-filter="filter"
                            let-filterService="filterService">
                            <nova-date-range-filter [allowSameDaySelection]="column.needSameDaySelection" [field]="column.field"
                                [filter]="filter" [filterService]="filterService"
                                [uniqueFilterClass]="column.field + '-' + column.filterType + '-filter'">
                            </nova-date-range-filter>
                        </ng-template>
                    }
            }

            @if(column.filterTemplate) {
                <!-- custom filter menu template -->
                <ng-template kendoGridFilterMenuTemplate let-filter="filter"
                    let-filterService="filterService">
                    <ng-container [ngTemplateOutlet]="column.filterTemplate"
                        [ngTemplateOutletContext]="{ column: column, filter: filter, filterService: filterService }">
                    </ng-container>
                </ng-template>
            }

            @if(column.filterCellTemplate) {
                <!-- custom filter cell template -->
                <ng-template kendoGridFilterCellTemplate let-filter="filter">
                    <ng-container [ngTemplateOutlet]="column.filterCellTemplate"
                        [ngTemplateOutletContext]="{ column: column, filter: filter, filterService: filterService }">
                    </ng-container>
                </ng-template>
            }

            @if(column.footerTemplate) {
                <!-- custom footer template -->
                <ng-template kendoGridFooterTemplate>
                    <ng-container [ngTemplateOutlet]="column.footerTemplate">
                    </ng-container>
                </ng-template>
            }
        </kendo-grid-column>
    }

    @if(canExportToPdf) {
        <!-- PDF/Excel export -->
        <kendo-grid-pdf fileName="results.pdf" [allPages]="true" paperSize="A4"
            [repeatHeaders]="true" [landscape]="true">
            <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
            <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
                <div class="page-template">
                    <div class="footer">
                        Page {{ pageNum }} of {{ totalPages }}
                    </div>
                </div>
            </ng-template>
        </kendo-grid-pdf>
    }
    <kendo-grid-excel [fileName]="excelOutputFileName"></kendo-grid-excel>
    <mat-menu #columnPickerMenu="matMenu" [overlapTrigger]="false" >
        <mat-selection-list (selectionChange)="toggleVisibility($event)">
            @for(column of getSortedColumns(); track column) {
                @if(column.title && column.title !== ' ' && !column.groupTemplate) {
                    <mat-list-option [attr.data-qa-id]="'grid-column-' + column.field"
                        (click)="$event.stopPropagation()" [value]="column" [selected]="!column.hidden">
                        {{column.title}}
                    </mat-list-option>
                }
            }
        </mat-selection-list>
    </mat-menu>

    <mat-menu #savedFilterMenu="matMenu" [overlapTrigger]="false">
        @if(savedFiltersMenuTemplate) {
            <ng-container [ngTemplateOutlet]="savedFiltersMenuTemplate"></ng-container>
        }
    </mat-menu>


    <mat-menu #toolbarColumnMenu="matMenu" [overlapTrigger]="false">

        @for(item of toolbarMenuItems; track item.label ) {
            @if(item.visible) {
                <button type="button" [disabled]="item?.disabled" mat-menu-item
                    [matMenuTriggerFor]="item.subMenu && item.label === ToolbarMenuItem.ShowHideColumns
                    ? columnPickerMenu : (item.subMenu && item.label === ToolbarMenuItem.LoadFilters
                        ? savedFilterMenu : null)"
                    (click)="item.action?.()" [attr.data-cy]="item.dataCy" [attr.data-qa-id]="item.dataCy">
                        @switch(item.icon) {
                            @case('reset_settings') {
                                <mat-icon [svgIcon]="item.icon"></mat-icon>
                            }
                            @default {
                                <mat-icon>{{ item.icon }}</mat-icon>
                            }
                        }
                        {{ item.label }}
                </button>
            }
        }
    </mat-menu>

    <mat-menu #exportMenu="matMenu" [overlapTrigger]="false">
        @if(canExportToPdf) {
            <button type="button" mat-menu-item (click)="exportAllData('exportToPdf')">
                <kendo-svg-icon [icon]="pdfFileIcon"></kendo-svg-icon>Export to PDF
            </button>
        }

        @if(canExportToExcel) {
            <button type="button" mat-menu-item (click)="exportAllData('exportToExcel')">
                <kendo-svg-icon [icon]="excelFileIcon"></kendo-svg-icon>Export to Excel
            </button>
        }

        @if(canExportToCSV) {
            <button type="button" mat-menu-item (click)="exportAllData('exportToCSV')">
                <kendo-svg-icon [icon]="csvFileIcon"></kendo-svg-icon>Export to CSV
            </button>
        }

    </mat-menu>

    <mat-menu #bulkActionMenu="matMenu" [overlapTrigger]="false">
        @if(showNewRequirementsButtons()) {
            <button type="button" mat-menu-item [disabled]="isLoading"
                    [matMenuTriggerFor]="createNewMenu"
                    data-qa-id="CreateNewRequirementMenuItem">
                Create New Requirement
            </button>
        }

        @if(showFacilitySpecificButtons()) {
            <button type="button" mat-menu-item [disabled]="isLoading"
                    data-qa-id="ViewReqListMenuItem"
                    (click)="onViewReqList()">
                View Req List
            </button>

            <button type="button" mat-menu-item [disabled]="isLoading"
                    data-qa-id="CreateNewRequirementMenuItem"
                    (click)="onCreateNewFacilityRequirement()">
                Create New Requirement
            </button>
        }

        @if(showClientPortalVisibilityButton()) {
            <button type="button" mat-menu-item
                data-qa-id="EditClientPortalVisibilityMenuItem"
                (click)="onEditClientPortalVisibilityClicked()">
                Edit Client Portal Visibility
            </button>
        }

        @if(specialPermissions()?.canReassignCL || specialPermissions()?.canUnassignCL) {
            <button type="button" mat-menu-item [disabled]="selectedRows.length === 0 || isLoading"
                    [matMenuTriggerFor]="clSubMenu"
                    data-qa-id="EditClMenuItem">
                Edit CL
            </button>
        }

        @if(specialPermissions()?.canReassignCS || specialPermissions()?.canUnassignCS) {
            <button type="button" mat-menu-item [disabled]="selectedRows.length === 0 || isLoading"
                    [matMenuTriggerFor]="csSubMenu"
                    data-qa-id="EditCsMenuItem">
                Edit CS
            </button>
        }

        @if(specialPermissions()?.canAssignQm) {
            <button type="button" mat-menu-item [disabled]="selectedRows.length === 0 || isLoading"
                    (click)="onAssignQmClicked()"
                    data-qa-id="AssignQmMenuItem">
                Assign QM Association
            </button>
        }

        @if(showBulkEditStatusButton && specialPermissions()?.canEditQualificationMapping) {
            <button type="button" mat-menu-item [disabled]="selectedRows.length === 0 || isLoading"
                    (click)="onBulkEditQualificationMapping()"
                    data-qa-id="EditStatusMenuItem">
                Edit Status
            </button>
        }

        @if(specialPermissions()?.canBulkEditACStatus) {
            <button type="button" mat-menu-item
                    [disabled]="selectedRows.length === 0 || isLoading"
                    (click)="onBulkEditACStatus()"
                    data-qa-id="EditACStatusMenuItem">
                Edit AC Status
            </button>
        }

        <!-- Built-in menu items based on specialPermissions (mirrors toolbar buttons) -->
        @if(specialPermissions()?.canBulkSetAutMatchSettings) {
            <button type="button" mat-menu-item [disabled]="selectedRows.length === 0 || isLoading"
                    (click)="onEditAutomatchSettingsClicked()"
                    data-qa-id="EditAutomatchSettingsMenuItem">
                Edit Automatch Settings
            </button>
        }

        @if(specialPermissions()?.canBulkSetQmAutMatchSettings) {
            <button type="button" mat-menu-item [disabled]="selectedRows.length === 0 || isLoading"
                    (click)="onEditQmAutomatchSettingsClicked()"
                    data-qa-id="EditQmAutomatchSettingsMenuItem">
                Edit Automatch Settings
            </button>
        }

    </mat-menu>

    <mat-menu #csSubMenu="matMenu">
        @if(specialPermissions()?.canReassignCS) {
            <button type="button" mat-menu-item (click)="onCSReassignClicked()"
                    data-qa-id="ReassignCsMenuItem">
                Reassign CS
            </button>
        }

        @if(specialPermissions()?.canUnassignCS) {
            <button type="button" mat-menu-item (click)="onCSUnassignClicked()"
                    data-qa-id="UnassignCsMenuItem">
                Unassign CS
            </button>
        }
    </mat-menu>

    <mat-menu #clSubMenu="matMenu">
        @if(specialPermissions()?.canReassignCL) {
            <button type="button" mat-menu-item (click)="onCLReassignClicked()"
                    data-qa-id="ReassignClMenuItem">
                Reassign CL
            </button>
        }

        @if(specialPermissions()?.canUnassignCL) {
            <button type="button" mat-menu-item (click)="onCLUnassignClicked()"
                    data-qa-id="UnassignClMenuItem">
                Unassign CL
            </button>
        }
    </mat-menu>

    <mat-menu #createNewMenu="matMenu">
        @if(canCreateNewTravelRequirement()){
            <button type="button" mat-menu-item (click)="onCreateNewTravelRequirement()"
                    data-qa-id="CreateNewTravelRequirementMenuItem">
                Travel
            </button>
        }
        @if(canCreateNewLocumsRequirement()){
            <button type="button" mat-menu-item (click)="onCreateNewLocumsRequirement()"
                    data-qa-id="CreateNewLocumsRequirementMenuItem">
                Locums
            </button>
        }
        @if(canCreateNewAccessControlRequirement()){
            <button type="button" mat-menu-item (click)="onCreateNewAccessControlRequirement()"
                    data-qa-id="CreateNewAccessControlRequirementMenuItem">
                Access Control
            </button>
        }
    </mat-menu>

    @if(needDetailView && detailViewTemplate) {
        <!-- detail view -->
        <ng-template kendoGridDetailTemplate let-dataItem>
            <ng-container [ngTemplateOutlet]="detailViewTemplate"
                [ngTemplateOutletContext]="{ dataItem: dataItem }"></ng-container>
        </ng-template>
    }

    @if(!isLoading) {
        <ng-template kendoGridNoRecordsTemplate>
            {{ noRecordsMessage }}
        </ng-template>
    }

    <!-- Adapted example from here: https://www.telerik.com/kendo-angular-ui/components/indicators/loader/integration/#toc-loader-in-a-loading-panel -->
    <!-- See also here: https://www.telerik.com/kendo-angular-ui/components/styling/loader/ -->
    <!-- Kendo now has a separate loader component and allows the grid to specify it's own loading icon. Here we use the Material progress spinner -->
    <ng-template kendoGridLoadingTemplate>
        @if(isLoading) {
            <div class="loading-panel">
                <div class="loading-panel-mask"></div>
                @if(!useUnpagedLoadingSpinner) {
                    <div class="loading-panel-wrapper">
                        <mat-spinner></mat-spinner>
                    </div>
                } @else {
                    <div class="unpaged-loading-panel-wrapper">
                        <mat-spinner></mat-spinner>
                    </div>
                }
            </div>
        }
    </ng-template>

</kendo-grid>
